import { render, staticRenderFns } from "./FrenchWindowDamageSeverity.vue?vue&type=template&id=59eddf0e&scoped=true"
import script from "./FrenchWindowDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eddf0e",
  null
  
)

export default component.exports